

























import {Component, Provide} from "vue-property-decorator";
import {LadingStore} from "@/modules/ladings/store";
import LadingSearch from "@/modules/ladings/List/components/Search.vue";
import LadingTableAction from "@/modules/ladings/List/components/TableAction.vue";
import moment from 'moment';
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import DetailLadingPrint from "@/modules/ladings/Print/components/Detail.vue";
import {Options} from "@/plugins/print/lib/print";
import {getPublicPath, getValuesEnum} from "@/shared/services/helper/utils";
import {LadingParams} from "@/modules/ladings/params";
import LadingTable from "@/modules/ladings/List/components/Table.vue";
import {LadingStatus} from '@/enums/status';
import {difference} from "lodash";
import LadingPrintBill from "@/modules/ladings/Print/Bill/index.vue";
import PrintLading from "@/modules/ladings/Print/index.vue";
import LadingListExcel from "@/modules/ladings/List/components/ExportExcel.vue";
import {exportExcelLading} from "@/modules/ladings/services";
import TableToExcel from "@linways/table-to-excel";

@Component({
    name: "LadingList",
    components: {
        LadingListExcel,
        PrintLading,
        LadingPrintBill, LadingTable, DetailLadingPrint, LadingStatusLabel, LadingTableAction, LadingSearch
    }
})
export default class extends mixins(CommonMixin) {
    visibleModal = false;
    @Provide() routingEdit = true;
    moment = moment;
    // selectedRowLadings: string[] = [];
    billLadingsExcel = [] as any;
    isExport = false;
    columns = [
        {
            title: "Mã vận đơn",
            dataIndex: "ladingCode",
            key: "ladingCode"
        },
        {
            title: "Mã đơn hàng",
            dataIndex: "orderCode",
            key: "orderCode"
        },
        {
            title: "Đại diện gửi",
            dataIndex: "locationFromId",
            key: "locationFromId",
            scopedSlots: {customRender: "locationFromId"}
        },
        {
            title: "Người nhận",
            dataIndex: "locationToId",
            key: "locationToId",
            scopedSlots: {customRender: "locationToId"}
        },
        {
            title: "Hàng hóa",
            dataIndex: "boxContent",
            key: "boxContent",
        },
        {
            title: "Ngày lập",
            dataIndex: "ladingDate",
            key: "ladingDate",
            scopedSlots: {customRender: "ladingDate"}
        },
        {
            title: "Thu hộ",
            dataIndex: "codMoney",
            key: "codMoney",
            scopedSlots: {customRender: "codMoney"}
        },
        {
            title: "Tổng cước",
            dataIndex: "totalFee",
            key: "totalFee",
            scopedSlots: {customRender: "totalFee"}
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            scopedSlots: {customRender: 'status'},
        },
        {
            title: "Thao tác",
            dataIndex: "rowGuid",
            key: "rowGuid",
            scopedSlots: {customRender: 'action'},
        }
    ];
    printObj: Options = {
        id: 'print-lading-list',
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`
    };

    created() {
        const statusString = difference(getValuesEnum(LadingStatus), [
            ...this.LADING_STATUS_BEFORE_STOCKIN,
            LadingStatus.Reject
        ]).join(",");
        const params = {...new LadingParams(), statusString};
        LadingStore.updateLadingParams(params);
        LadingStore.listLading(params)
    }

    get selectedRowLadings() {
        return LadingStore.selectedRowLadings;
    }

    printLadings() {
        this.$print(this.printObj);
    }

    async exportExcel() {
        await this.getDataExport();
        setTimeout(() => {
            TableToExcel.convert(document.getElementById("table-excel-lading-list"), {
                name: `Danh sách vận đơn.xlsx`,
                sheet: {
                    name: "Sheet 1"
                }
            });
        }, 200)
    }

    async getDataExport() {
        try {
            this.isExport = true;
            const { data } = await exportExcelLading(LadingStore.params);
            this.billLadingsExcel = data.datas;
        } catch (e) {
        } finally {
            this.isExport = false;
        }
    }
}
